import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { App as AntdApp } from 'antd'; // 引入 antd 的 App 组件
import { setupMocks } from './mock';

// 初始化 mock
setupMocks();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AntdApp>
      <App />
    </AntdApp>
  </React.StrictMode>
);
